import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {

  constructor() { }

  // tipo do spinner
  @Input() spinnerType: string = 'grow';

  // tamanho do spinner
  @Input() spinnerWidth!: string;

  ngOnInit(): void {
  }

}
